import React from 'react';

function UploadIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11 0C12.6569 0 14 1.34315 14 3V11C14 12.6569 12.6569 14 11 14H3C1.34315 14 0 12.6569 0 11V3C0 1.34315 1.34315 0 3 0H11ZM6.38388 3.48744C6.38388 3.21129 6.60774 2.98744 6.88388 2.98744C7.16003 2.98744 7.38388 3.21129 7.38388 3.48744L7.38398 6.04836L7.38407 8.60928L9.0052 6.98744C9.20047 6.79217 9.51705 6.79217 9.71231 6.98744C9.90757 7.1827 9.90757 7.49928 9.71231 7.69454L7.23744 10.1694C7.04218 10.3647 6.72559 10.3647 6.53033 10.1694L4.05546 7.69454C3.86019 7.49928 3.86019 7.1827 4.05546 6.98744C4.25072 6.79217 4.5673 6.79217 4.76256 6.98744L6.38422 8.60857L6.38405 6.048L6.38388 3.48744Z" fill="black"/>
        </svg>

    );
}

export default UploadIcon;